import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageDatasetInstructionDetailComponent } from './page.dataset.instruction.detail/page.dataset.instruction.detail.component';
import { PageDatasetFinetuneDetailComponent } from './page.dataset.finetune.detail/page.dataset.finetune.detail.component';
import { PageCollectionsComponent } from './page.collections/page.collections.component';
import { PageReviewDetailComponent } from './page.review.detail/page.review.detail.component';
import { PageDatasetInstructionComponent } from './page.dataset.instruction/page.dataset.instruction.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageDatasetFinetuneComponent } from './page.dataset.finetune/page.dataset.finetune.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageUserComponent } from './page.user/page.user.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageDpiComponent } from './page.dpi/page.dpi.component';
import { PageRefactoringComponent } from './page.refactoring/page.refactoring.component';
import { PageReportComponent } from './page.report/page.report.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageSetComponent } from './page.set/page.set.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PageReviewComponent } from './page.review/page.review.component';
import { PageAccessComponent } from './page.access/page.access.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonFormDropdownComponent,
        PageDatasetInstructionDetailComponent,
        PageDatasetFinetuneDetailComponent,
        PageCollectionsComponent,
        PageReviewDetailComponent,
        PageDatasetInstructionComponent,
        LayoutEmptyComponent,
        PortalSeasonModalComponent,
        ComponentNavSidebarComponent,
        PortalSeasonPaginationComponent,
        PageDatasetFinetuneComponent,
        PageMembersComponent,
        PageUserComponent,
        PortalSeasonTreeComponent,
        PortalPostDetailComponent,
        PortalSeasonLoadingSeasonComponent,
        PageDpiComponent,
        PageRefactoringComponent,
        PageReportComponent,
        PortalSeasonLoadingDefaultComponent,
        PageSetComponent,
        PageMypageComponent,
        PortalPostListComponent,
        LayoutSidebarComponent,
        PageAdminComponent,
        PageReviewComponent,
        PageAccessComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }